import { ForwardRefExoticComponent } from 'react';

import {
  LayoutDashboard,
  LucideProps,
  Home,
  Phone,
  PhoneIncoming,
  UserPlus,
  Users,
  GitBranchPlus,
  Check,
  X,
  Volume2,
  Trash,
  Pencil,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronsRight,
  ChevronsLeft,
  MapPin,
  Mail,
  Globe,
  Clock,
  Map,
  Calendar,
  RefreshCw,
  Settings,
  ExternalLink,
  Search,
  Filter,
  Building2,
  CheckCircle2,
  AlertCircle,
  HelpCircle,
  Hash,
  PlusCircle,
  Download,
  ArrowRight,
  ArrowLeft,
  Cloud,
  Star,
  ThumbsUp,
  ThumbsDown,
  FileText,
  BarChart3,
  Workflow,
  GripVertical,
  List,
  MoreVertical,
  Play,
  Pause,
  Square,
  Copy,
} from 'lucide-react';

export const OrbitAvailableIcons: { [s: string]: ForwardRefExoticComponent<LucideProps> } = {
  home: Home,
  'layout-dashboard': LayoutDashboard,
  phone: Phone,
  'phone-incoming': PhoneIncoming,
  'user-plus': UserPlus,
  users: Users,
  'git-branch-plus': GitBranchPlus,
  check: Check,
  x: X,
  'volume-2': Volume2,
  trash: Trash,
  pencil: Pencil,
  'chevron-down': ChevronDown,
  'chevron-left': ChevronLeft,
  'chevrons-left': ChevronsLeft,
  'chevron-right': ChevronRight,
  'chevrons-right': ChevronsRight,
  'map-pin': MapPin,
  mail: Mail,
  globe: Globe,
  clock: Clock,
  map: Map,
  calendar: Calendar,
  'refresh-cw': RefreshCw,
  settings: Settings,
  'external-link': ExternalLink,
  search: Search,
  filter: Filter,
  'building-2': Building2,
  'check-circle-2': CheckCircle2,
  'alert-circle': AlertCircle,
  'help-circle': HelpCircle,
  hash: Hash,
  'plus-circle': PlusCircle,
  download: Download,
  'arrow-right': ArrowRight,
  'arrow-left': ArrowLeft,
  cloud: Cloud,
  star: Star,
  'thumbs-up': ThumbsUp,
  'thumbs-down': ThumbsDown,
  'file-text': FileText,
  'bar-chart-3': BarChart3,
  workflow: Workflow,
  'grip-vertical': GripVertical,
  list: List,
  'more-vertical': MoreVertical,
  play: Play,
  pause: Pause,
  square: Square,
  copy: Copy,
};

export const OrbitIcons = Object.freeze({
  LayoutDashboard: 'layout-dashboard',
  Phone: 'phone',
  PhoneIncoming: 'phone-incoming',
  UserPlus: 'user-plus',
  Home: 'home',
  Scaling: 'git-branch-plus',
  Check: 'check',
  X: 'x',
  Trash: 'trash',
  Pencil: 'pencil',
  ChevronDown: 'chevron-down',
  ChevronLeft: 'chevron-left',
  ChevronsLeft: 'chevrons-left',
  ChevronRight: 'chevron-right',
  ChevronsRight: 'chevrons-right',
  MapPin: 'map-pin',
  Mail: 'mail',
  Globe: 'globe',
  Clock: 'clock',
  Map: 'map',
  Calendar: 'calendar',
  RefreshCw: 'refresh-cw',
  Settings: 'settings',
  ExternalLink: 'external-link',
  Search: 'search',
  Filter: 'filter',
  Building: 'building-2',
  CheckCircle2: 'check-circle-2',
  AlertCircle: 'alert-circle',
  HelpCircle: 'help-circle',
  Hash: 'hash',
  PlusCircle: 'plus-circle',
  Download: 'download',
  ArrowRight: 'arrow-right',
  ArrowLeft: 'arrow-left',
  Cloud: 'cloud',
  Star: 'star',
  ThumbsUp: 'thumbs-up',
  ThumbsDown: 'thumbs-down',
  FileText: 'file-text',
  BarChart3: 'bar-chart-3',
  Workflow: 'workflow',
  GripVertical: 'grip-vertical',
  List: 'list',
  MoreVertical: 'more-vertical',
  Play: 'play',
  Pause: 'pause',
  Square: 'square',
  Copy: 'copy',
});
